import type {
    UpdateCommerceCartLineQuantityRequest,
    UpdateCommerceCartLineQuantityResponse,
} from "@teqtank/commerce-contracts";
import { defineCommerceOperation } from "@teqtank/commerce-transport";
export const updateCommerceCartLineQuantityOperation = defineCommerceOperation<
    UpdateCommerceCartLineQuantityRequest,
    UpdateCommerceCartLineQuantityResponse
>("commerce.cart.lines.update-quantity");
